import React, { Component } from 'react';
import PropTypes, { string } from 'prop-types';
import {
    TextField, Radio, RadioGroup, FormControlLabel, IconButton, Grid, Tooltip, Checkbox,
    Typography, TextareaAutosize, Box, ButtonGroup, Select, InputLabel, FormControl, MenuItem, Input, InputAdornment, OutlinedInput
} from '@material-ui/core';
import { EventRounded, AccessTimeRounded, CheckBox, CheckBoxOutlineBlank, Clear } from '@material-ui/icons';
import Autocomplete, { createFilterOptions } from '@material-ui/lab/Autocomplete';
import DateFnsUtils from "@date-io/date-fns";
import { DatePicker, TimePicker, KeyboardDatePicker, KeyboardTimePicker, MuiPickersUtilsProvider } from "@material-ui/pickers";
// 語系
import { zhTW } from 'date-fns/locale'
import { DateTimeFormate, base64FromFile } from "../../js/function";
import InputMask from 'react-input-mask-3.0';

/**
 * @description 底線類型日期選擇器
 * @param {string} locale 顯示語言 date-fns/locale 資料夾裡的資料夾 依據index.d.ts檔案內容給參數
 * @param {boolean} disableToolbar 選擇器 header
 * @param {string} id id
 * @param {string} label 標籤
 * @param {string} variant 跳出形式 "dialog" | "inline" | "static"
 * @param {string} size 大小
 * @param {string} value 值  給空值會被判斷成格式錯誤
 * @param {function} changeEvent onChange 事件
 * @param {string} invalidDateMessage 無效日期 提示文字
 * @param {boolean} showTodayButton 選擇今日按鈕
 * @param {boolean} autoOk 選擇日期就關閉選擇器
 * @param {boolean} disabled 是否可填
 * @param {boolean} required 是否必填
 */
class ReactMultDatePicker extends Component {
    constructor(props) {
        super(props);
        this.state = {}
    }
    render() {
        return (
            <MuiPickersUtilsProvider utils={DateFnsUtils} locale={zhTW}>
                <div style={{ margin: this.props.margin, maxHeight: '150px', width: "100%" }}>
                    <DatePicker
                        disableToolbar={true}
                        color={this.props.color === undefined ? "primary" : this.props.color}
                        variant="dialog"
                        label={this.props.label}
                        id={this.props.id}
                        name={this.props.name}
                        format="yyyy/MM/dd" //顯示型態
                        style={{ margin: "0.5rem 0" }}
                        value={this.props.value === "" ? null : DateTimeFormate.dateFormate({ dateStr: this.props.value })}
                        InputAdornmentProps={{ position: "end", }}
                        invalidDateMessage={this.props.required ? (this.props.invalidDateMessage === undefined ?
                            "請選擇有效日期格式" : this.props.invalidDateMessage) : ""}
                        size={this.props.size !== undefined ? this.props.size : "small"}
                        autoComplete={this.props.autoComplete !== undefined ? this.props.autoComplete : "off"}
                        showTodayButton={this.props.showTodayButton}
                        autoOk={this.props.autoOk !== undefined ? this.props.autoOk : true}
                        okLabel="確認"
                        cancelLabel="取消"
                        todayLabel="今日"
                        clearable={(this.props.id ?? "").indexOf("search--") > -1 && !this.props.required ? true : false}
                        clearLabel="X"
                        disabled={this.props.disabled}
                        // error={this.props.required === true ? (this.props.value === "" ? true : false) : false}
                        // helperText={this.props.required === true ? (this.props.value === "" ? "此為必填欄位" : "") : false}
                        required={this.props.required}
                        onChange={(e) => this.props.changeEvent({ "target": { "name": this.props.name, "value": e, "type": "date", } })}
                        fullWidth
                    />
                </div>
            </MuiPickersUtilsProvider>
        );
    }
}
/**
 * @description 型別判斷
 */
ReactMultDatePicker.propTypes = {
    id: PropTypes.string,
    disableToolbar: PropTypes.bool,
    label: PropTypes.string,
    variant: PropTypes.string,
    size: PropTypes.string,
    value: PropTypes.string,
    invalidDateMessage: PropTypes.string,
    showTodayButton: PropTypes.bool,
    autoOk: PropTypes.bool,
    disabled: PropTypes.bool,
    required: PropTypes.bool,
}


/**
 * @description 底線類型時間選擇器
 * @param {string} locale 顯示語言 date-fns/locale 資料夾裡的資料夾 依據index.d.ts檔案內容給參數
 * @param {string} id id
 * @param {string} label 標籤
 * @param {string} variant 跳出形式 "dialog" | "inline" | "static"
 * @param {string} size 大小
 * @param {string} value 值  給空值會被判斷成格式錯誤
 * @param {function} changeEvent onChange 事件
 * @param {string} invalidDateMessage 無效日期 提示文字
 * @param {boolean} showTodayButton 選擇今日按鈕
 * @param {boolean} autoOk 選擇日期就關閉選擇器
 * @param {boolean} disabled 是否可填
 * @param {boolean} required 是否必填
 */
class ReactMultTimePicker2 extends Component {
    constructor(props) {
        super(props);
        this.state = {}
    }
    render() {
        return (
            <MuiPickersUtilsProvider utils={DateFnsUtils} locale={zhTW}>
                <div style={{ margin: this.props.margin, maxHeight: '150px', width: this.props.width === undefined ? "100%" : this.props.width }}>
                    <TimePicker
                        style={{ margin: "0.5rem 0" }}
                        id={this.props.id}
                        label={this.props.label}
                        inputVariant="standard"
                        mask={this.props.ampm === undefined ? "__:__" : "__:__ _M"}
                        format={this.props.ampm === undefined ? "HH:mm" : "HH:mm a"}
                        ampm={this.props.ampm === undefined ? false : this.props.ampm}
                        size={this.props.size !== undefined ? this.props.size : "small"}
                        value={this.props.value === "" ? null : DateTimeFormate.dateFormate({
                            dateStr: "19110101" + this.props.value,
                            Mode: (this.props.mode === undefined ? "yyyyMMddhhmm" : this.props.mode)
                        })}
                        inputadornmentprops={{ position: "end" }}
                        onChange={(e) => this.props.changeEvent({ "target": { "name": this.props.name, "value": e, "type": "time", "key": (this.props.index === undefined ? "" : this.props.index) } })}
                        keyboardbuttonprops={{
                            size: "small",
                            "aria-label": "change time",
                        }}
                        placeholder={this.props.placeholder}
                        invalidDateMessage={this.props.required ? (this.props.invalidDateMessage === undefined ?
                            "請選擇有效日期格式" : this.props.invalidDateMessage) : ""}
                        showTodayButton={this.props.showTodayButton !== undefined ? this.props.showTodayButton : true}
                        autoOk={this.props.autoOk !== undefined ? this.props.autoOk : true}
                        okLabel="確認"
                        cancelLabel="取消"
                        todayLabel="現在"
                        clearable={(this.props.id ?? "").indexOf("search--") > -1 && !this.props.required ? true : false}
                        clearLabel="X"
                        disabled={this.props.disabled}
                        required={this.props.required}
                        keyboardicon={<AccessTimeRounded size="small" fontSize="inherit" />}
                        fullWidth
                    />
                </div>
            </MuiPickersUtilsProvider>
        );
    }
}
/**
 * @description 型別判斷
 */
ReactMultTimePicker2.propTypes = {
    id: PropTypes.string,
    label: PropTypes.string,
    variant: PropTypes.string,
    size: PropTypes.string,
    value: PropTypes.string,
    invalidDateMessage: PropTypes.string,
    showTodayButton: PropTypes.bool,
    autoOk: PropTypes.bool,
    disabled: PropTypes.bool,
    required: PropTypes.bool,
}

/**
 * @description 框線類型日期選擇器
 * @param {string} locale 顯示語言 date-fns/locale 資料夾裡的資料夾 依據index.d.ts檔案內容給參數
 * @param {string} id id
 * @param {string} label 標籤
 * @param {string} variant 跳出形式 "dialog" | "inline" | "static"
 * @param {string} size 大小
 * @param {string} value 值  給空值會被判斷成格式錯誤
 * @param {function} changeEvent onChange 事件
 * @param {string} invalidDateMessage 無效日期 提示文字
 * @param {boolean} showTodayButton 選擇今日按鈕
 * @param {boolean} autoOk 選擇日期就關閉選擇器
 * @param {boolean} disabled 是否可填
 * @param {boolean} required 是否必填
 * @param {ParsableDate} minDate 最小日期(Date)
 * @param {ParsableDate} maxDate 最大日期(Date)
 * @param {Array} views ["date"] ["year"] ["month"]
 * @param {string} errorText 錯誤提示文字
 * @param {boolean} pickerOnly 只能透過日曆圖示選日期(禁止鍵盤輸入與清空)
 */
class ReactOutlineDatePicker extends Component {
    constructor(props) {
        super(props);
        this.state = {}
    }
    render() {
        return (
            <MuiPickersUtilsProvider utils={DateFnsUtils} locale={zhTW}>
                <div style={{ margin: this.props.margin, maxHeight: '150px', width: "100%" }}>
                    <KeyboardDatePicker
                        style={{ margin: "0.5rem 0" }}
                        id={this.props.id}
                        label={this.props.label}
                        readOnly={this.props.readOnly === undefined ? false : this.props.readOnly}
                        color={this.props.color === undefined ? "primary" : this.props.color}
                        variant={this.props.variant === undefined ? "dialog" : this.props.variant}
                        inputVariant="outlined" // 框線樣式
                        format={this.props.format === undefined ? "yyyy/MM/dd" : this.props.format} //顯示型態
                        views={this.props.views === undefined ? ["date"] : this.props.views}
                        size={this.props.size !== undefined ? this.props.size : "small"}
                        value={this.props.value ? DateTimeFormate.dateFormate({ dateStr: this.props.value }) : null}
                        autoComplete={this.props.autoComplete !== undefined ? this.props.autoComplete : "off"}
                        InputAdornmentProps={{ position: "end", }}
                        onChange={(e) => {
                            // 只有在日期有效或是 null 時才傳遞，避免鍵盤輸入過程中的無效狀態觸發後續解析
                            if (e === null || (e instanceof Date && !isNaN(e.getTime()))) {
                                this.props.changeEvent({ "target": { "name": this.props.name, "value": e, "type": "date", } })
                            }
                        }}
                        KeyboardButtonProps={{
                            size: "small",
                            "aria-label": "change date"
                        }}
                        invalidDateMessage={this.props.required ? (this.props.invalidDateMessage === undefined ?
                            "請選擇有效日期格式" : this.props.invalidDateMessage) : ""}
                        minDate={this.props.minDate}
                        maxDate={this.props.maxDate}
                        maxDateMessage={"請注意 ! 最大可選日期為 " + (this.props.maxDate ? DateTimeFormate.dateToString({ date: this.props.maxDate, Mode: "yyyyMMdd", joinDate: "-" }) : "(2100-01-01)")}
                        minDateMessage={"請注意 ! 最小可選日期為 " + (this.props.minDate ? DateTimeFormate.dateToString({ date: this.props.minDate, Mode: "yyyyMMdd", joinDate: "-" }) : "(1900-01-01)")}
                        showTodayButton={this.props.showTodayButton !== undefined ? this.props.showTodayButton : true}
                        autoOk={this.props.autoOk !== undefined ? this.props.autoOk : true}
                        okLabel="確認"
                        cancelLabel="取消"
                        todayLabel="今日"
                        clearable={this.props.pickerOnly === true ? false : ((this.props.id ?? "").indexOf("search--") > -1 && !this.props.required ? true : false)}
                        clearLabel="X"
                        disabled={this.props.disabled}
                        error={!!this.props.errorText}
                        helperText={this.props.errorText || this.props.helperText}
                        required={this.props.required}
                        InputProps={{
                            // pickerOnly：輸入框設為唯讀，禁止手動輸入或刪除，只能用旁邊的日曆圖示挑選
                            readOnly: this.props.pickerOnly === true ? true : undefined,
                            startAdornment: this.props.startAdornment,
                            endAdornment: this.props.endAdornment
                        }}
                        keyboardIcon={<EventRounded size="small" fontSize="inherit" />}
                        fullWidth
                    />
                </div>
            </MuiPickersUtilsProvider>
        );
    }
}

/**
 * @description 型別判斷
 */
ReactOutlineDatePicker.propTypes = {
    id: PropTypes.string,
    label: PropTypes.string,
    variant: PropTypes.string,
    size: PropTypes.string,
    value: PropTypes.string,
    invalidDateMessage: PropTypes.string,
    showTodayButton: PropTypes.bool,
    autoOk: PropTypes.bool,
    disabled: PropTypes.bool,
    required: PropTypes.bool,
    pickerOnly: PropTypes.bool,
}


/**
 * @description 框線類型日期時間選擇器
 * 
 */
class ReactOutlineDateTimePicker extends Component {
    constructor(props) {
        super(props);
        this.state = {}
    }
    render() {
        // let telCheck = Regex.IsMatch(tel, @"^09[0-9]{8}$")
        return (
            <React.Fragment>
                {this.props.tiptitle !== undefined ? // 要不要有 tooltip
                    <Grid item lg={12} md={12} xs={12} style={{ display: "flex", justifyContent: "flex-end", }}>
                        <Tooltip style={{ margin: "0 1rem", padding: "0 !important" }} data-aria={this.props.aria}
                            enterTouchDelay={0}
                            placement={this.props.tipplacement} title={this.props.tiptitle} arrow={this.props.tiparrow}>
                            <IconButton size={this.props.tipsize} color={this.props.tipcolor}>
                                {this.props.tipicon}
                            </IconButton>
                        </Tooltip>
                    </Grid>
                    : ""}
                <div style={{ margin: this.props.margin, maxHeight: '150px', }}>
                    <TextField
                        style={{ margin: "0.5rem 0" }}
                        size={this.props.size !== undefined ? this.props.size : "small"}
                        id={this.props.id}
                        type="datetime-local"
                        name={this.props.name}
                        label={this.props.label}
                        // defaultValue={this.state.default}
                        value={this.props.value}
                        placeholder={this.props.placeholder}
                        variant="outlined"
                        color={this.props.color === undefined ? "primary" : this.props.color}
                        error={!!this.props.errorText}
                        helperText={this.props.errorText || this.props.helperText}
                        required={this.props.required}
                        autoComplete={this.props.autoComplete !== undefined ? this.props.autoComplete : "off"}
                        // onInput={this.props.change}
                        onChange={(e) => this.props.changeEvent(e)}
                        // onChange={this.props.type !== "date" ? (e) => this.props.changeEvent(e) : null}
                        fullWidth
                        InputLabelProps={{
                            shrink: this.props.shrink !== undefined ? this.props.shrink : true,
                        }}
                        inputProps={{
                            min: 0,
                            max: this.props.max,
                            maxLength: this.props.maxLength,
                        }}
                        disabled={this.props.disabled}
                    />
                </div>
            </React.Fragment>
        );
    }
}
/**
 * ReactOutlineDateTimePicker
 * @description 型別判斷
 */
ReactOutlineDateTimePicker.propTypes = {
    size: PropTypes.string,
    id: PropTypes.string,
    color: PropTypes.string,
    // default: PropTypes.node,
    disabled: PropTypes.bool,
    required: PropTypes.bool,
    helperText: PropTypes.node,
    placeholder: PropTypes.string,
    label: PropTypes.node,
    shrink: PropTypes.bool,
    maxLength: PropTypes.number,
    change: PropTypes.func,
    errorText: PropTypes.string,
}

/**
 * @description 框線類型時間選擇器
 */
class ReactOutlineTimePicker extends Component {
    constructor(props) {
        super(props);
        this.state = {}
    }
    render() {
        return (
            <MuiPickersUtilsProvider utils={DateFnsUtils} locale={zhTW}>
                <div style={{ margin: this.props.margin, maxHeight: '150px', width: "100%" }}>
                    <KeyboardTimePicker
                        style={{ margin: "0.5rem 0" }}
                        color={this.props.color === undefined ? "primary" : this.props.color}
                        id={this.props.id}
                        label={this.props.label}
                        variant={this.props.variant === undefined ? "dialog" : this.props.variant}
                        inputVariant="outlined" // 框線樣式
                        mask={this.props.ampm === undefined ? "__:__" : "__:__ _M"}
                        format={this.props.ampm === undefined ? "HH:mm" : "HH:mm a"}
                        ampm={this.props.ampm === undefined ? false : this.props.ampm}
                        size={this.props.size !== undefined ? this.props.size : "small"}
                        value={this.props.value === "" ? null : DateTimeFormate.dateFormate({
                            dateStr: "19110101" + this.props.value,
                            Mode: (this.props.mode === undefined ? "yyyyMMddhhmm" : this.props.mode)
                        })}
                        InputAdornmentProps={{ position: "end", }}
                        onChange={(e) => {
                            // 只有在時間有效或是 null 時才傳遞
                            if (e === null || (e instanceof Date && !isNaN(e.getTime()))) {
                                this.props.changeEvent({ "target": { "name": this.props.name, "value": e, "type": "time", "key": (this.props.index === undefined ? "" : this.props.index) } })
                            }
                        }}
                        KeyboardButtonProps={{
                            size: "small",
                            "aria-label": "change time",
                        }}
                        // placeholder="08:00 AM"
                        invalidDateMessage={this.props.required ? (this.props.invalidDateMessage === undefined ?
                            "請選擇有效日期格式" : this.props.invalidDateMessage) : ""}
                        showTodayButton={this.props.showTodayButton !== undefined ? this.props.showTodayButton : true}
                        autoOk={this.props.autoOk !== undefined ? this.props.autoOk : true}
                        okLabel="確認"
                        cancelLabel="取消"
                        todayLabel="現在"
                        clearable={(this.props.id ?? "").indexOf("search--") > -1 && !this.props.required ? true : false}
                        clearLabel="X"
                        disabled={this.props.disabled}
                        required={this.props.required}
                        keyboardicon={<AccessTimeRounded size="small" fontSize="inherit" />}
                        fullWidth
                        error={!!this.props.errorText}
                        helperText={this.props.errorText || this.props.helperText}
                    />
                </div>
            </MuiPickersUtilsProvider>
        );
    }
}

/**
 * @description 框線類型時間選擇器
 * @param {string} locale 顯示語言 date-fns/locale 資料夾裡的資料夾 依據index.d.ts檔案內容給參數
 * @param {string} id id
 * @param {string} label 標籤
 * @param {string} variant 跳出形式 "dialog" | "inline" | "static"
 * @param {string} size 大小
 * @param {string} value 值  給空值會被判斷成格式錯誤
 * @param {function} changeEvent onChange 事件
 * @param {string} invalidDateMessage 無效日期 提示文字
 * @param {boolean} showTodayButton 選擇今日按鈕
 * @param {boolean} autoOk 選擇日期就關閉選擇器
 * @param {boolean} disabled 是否可填
 * @param {boolean} required 是否必填
 */
class ReactOutlineTimePicker2 extends Component {
    constructor(props) {
        super(props);
        this.state = {}
    }
    render() {
        return (
            <MuiPickersUtilsProvider utils={DateFnsUtils} locale={zhTW}>
                <div style={{ margin: this.props.margin, maxHeight: '150px', width: "100%" }}>
                    <TimePicker
                        style={{ margin: "0.5rem 0" }}
                        id={this.props.id}
                        label={this.props.label}
                        variant={this.props.variant === undefined ? "dialog" : this.props.variant}
                        inputVariant="outlined" // 框線樣式
                        mask={this.props.ampm === undefined ? "__:__" : "__:__ _M"}
                        format={this.props.ampm === undefined ? "HH:mm" : "HH:mm a"}
                        ampm={this.props.ampm === undefined ? false : this.props.ampm}
                        size={this.props.size !== undefined ? this.props.size : "small"}
                        value={this.props.value === "" ? null : DateTimeFormate.dateFormate({
                            dateStr: "19110101" + this.props.value,
                            Mode: (this.props.mode === undefined ? "yyyyMMddhhmm" : this.props.mode)
                        })}
                        inputadornmentprops={{ position: "end" }}
                        onChange={(e) => this.props.changeEvent({ "target": { "name": this.props.name, "value": e, "type": "time", "key": (this.props.index === undefined ? "" : this.props.index) } })}
                        keyboardbuttonprops={{
                            size: "small",
                            "aria-label": "change time",
                        }}
                        placeholder={this.props.placeholder}
                        invalidDateMessage={this.props.required ? (this.props.invalidDateMessage === undefined ?
                            "請選擇有效日期格式" : this.props.invalidDateMessage) : ""}
                        showTodayButton={this.props.showTodayButton !== undefined ? this.props.showTodayButton : true}
                        autoOk={this.props.autoOk !== undefined ? this.props.autoOk : true}
                        okLabel="確認"
                        cancelLabel="取消"
                        todayLabel="現在"
                        clearable={(this.props.id ?? "").indexOf("search--") > -1 && !this.props.required ? true : false}
                        clearLabel="X"
                        disabled={this.props.disabled}
                        required={this.props.required}
                        keyboardicon={<AccessTimeRounded size="small" fontSize="inherit" />}
                        fullWidth
                    />
                </div>
            </MuiPickersUtilsProvider>
        );
    }
}
/**
 * @description 型別判斷
 */
ReactOutlineTimePicker2.propTypes = {
    id: PropTypes.string,
    label: PropTypes.string,
    variant: PropTypes.string,
    size: PropTypes.string,
    value: PropTypes.string,
    invalidDateMessage: PropTypes.string,
    showTodayButton: PropTypes.bool,
    autoOk: PropTypes.bool,
    disabled: PropTypes.bool,
    required: PropTypes.bool,
}

/**
 * @description 框線類型選單
 * @param {string} size 選單大小
 * @param {string} id 選單 id
 * @param {string} color 主顏色
 * @param {string} default 預設進畫面顯示的值
 * @param {function} inputEvent 選單 onChange 事件
 * @param {function} changeEvent 選單 onChange 事件
 * @param {function} openEvent 選單 onOpen 事件
 * @param {function} closeEvent 選單 onClose 事件
 * @param {boolean} open 開/關
 * @param {array} codeList 選單選項
 * @param {boolean} focused 是否focus
 * @param {boolean} autoFocus 是否自動focus
 * @param {boolean} disabled 是否禁止改值
 * @param {boolean} freeSolo 是否freeSolo
 * @param {boolean} enableCustomInput 是否允許在輸入框中自定義輸入（選項最底下會跳出“搜尋XXX”），freeSolo必須為true才能正常運作
 * @param {boolean} clearOnBlur 是否在失焦的時候清除
 * @param {string} matchFrom any:讓組件可以輸入任意的質做查詢  | start: 只能從文字的頭開始比對選項
 * @param {boolean} required 是否必填
 * @param {node} helperText 輔助文本
 * @param {string} placeholder 提示輸入
 * @param {boolean} disableClearable true/false 值是否要可以給空值
 * @param {boolean} loading 是否顯示載入中
 * @param {node} label input label
 * @param {boolean} shrink label 是否要直接顯示 true/false (如果要focus再出現，此屬性不要給)
 * @param {string} attribute data-attr 要帶系統代碼的spp_id
 * @param {string} closeIcon 清除按鈕
 * @param {string} aria 給 simple 就是不要 padding
 * @param {string} variant 樣式 'filled'| 'outlined'| 'standard'
 * InputProps 用於Input組件 & inputProps 是為input元素
 * function(event: object, value: T | T[], reason: string) => void ， 例:onChange={(e, value, reason) => this.props.changeEvent(e, value, reason)} 
 * @param {(option: string) => boolean} optionDisabled - 判斷選項是否禁用的函式
 * @param {string} errorText 錯誤提示文字
 */
class ReactOutlineSelect extends Component {
    constructor(props) {
        super(props);
        this.state = {
            selectedValues: [],
        }
        this.filterOptions.bind(this);
        this.input = React.createRef();
    }

    handleFocus = () => this.input.focus();

    /**
     * @description 顯示輸入比對到內容索引
     */
    filterOptions = createFilterOptions({
        matchFrom: this.props.matchFrom === undefined ? 'start' : this.props.matchFrom,
        stringify: (option) => option.name.toString(),
    });
    render() {
        const safeCodeList = Array.isArray(this.props.codeList) ? this.props.codeList : [];
        let styleObj = this.props.inputStyle === undefined ?
            { margin: "0.6rem 0" } :
            { margin: "0.6rem 0", ...this.props.inputStyle };
        const isMultiple = this.props.multiple === undefined ? false : this.props.multiple;
        const normalizedValue = isMultiple
            ? (Array.isArray(this.props.value) ? this.props.value.filter(elem => elem != null) : [])
            : (this.props.value ? this.props.value : null);
        return (
            <React.Fragment>
                {this.props.tiptitle !== undefined ? // 要不要有 tooltip
                    <Grid item lg={12} md={12} xs={12} style={{ display: "flex", justifyContent: "flex-end", }}>
                        <Tooltip style={{ margin: "0 1rem", padding: "0 !important" }} data-aria={this.props.aria}
                            enterTouchDelay={0}
                            placement={this.props.tipplacement} title={this.props.tiptitle} arrow={this.props.tiparrow}>
                            <IconButton size={this.props.tipsize} color={this.props.tipcolor}>
                                {this.props.tipicon}
                            </IconButton>
                        </Tooltip>
                    </Grid>
                    : ""}
                {window.innerWidth > 768 ?
                    <Autocomplete
                        open={this.props.open}
                        style={{ margin: this.props.margin, maxHeight: '150px', width: "100%" }}
                        size={"small"}
                        id={this.props.id}
                        color={this.props.color === undefined ? "primary" : this.props.color}
                        value={normalizedValue}
                        openOnFocus={true}
                        onFocus={(e) => {
                            if (this.props.focusEvent !== undefined) {
                                this.props.focusEvent({
                                    "target": {
                                        "id": this.props.id,
                                        "name": this.props.name,
                                        "key": (this.props.optionKey === undefined ? "" : this.props.optionKey),
                                    }
                                });
                            }
                        }}

                        onBlur={(e) => {
                            if (this.props.blurEvent !== undefined) {
                                this.props.blurEvent({
                                    "target": {
                                        "id": this.props.id,
                                        "name": this.props.name,
                                        "key": (this.props.optionKey === undefined ? "" : this.props.optionKey),
                                    }
                                });
                            }
                        }}
                        onInputChange={(e, value, reason) => {
                            if (this.props.inputEvent !== undefined)
                                this.props.inputEvent({
                                    "target": {
                                        "id": this.props.id,
                                        "name": this.props.name,
                                        "value": value,
                                        "key": (this.props.optionKey === undefined ? "" : this.props.optionKey),
                                    }
                                }, reason
                                )
                        }}
                        onChange={(e, value, reason) => {
                            if (this.props.changeEvent !== undefined)
                                this.props.changeEvent({
                                    "target": {
                                        "id": this.props.id,
                                        "name": this.props.name,
                                        "value": value,
                                        "key": (this.props.optionKey === undefined ? "" : this.props.optionKey),
                                    }
                                })
                        }}
                        onOpen={(e) => {
                            if (this.props.openEvent !== undefined)
                                this.props.openEvent(e)
                        }}
                        onClose={(e) => {
                            if (this.props.closeEvent !== undefined)
                                this.props.closeEvent({
                                    "target": {
                                        "id": this.props.id,
                                        "name": this.props.name,
                                        "key": (this.props.optionKey === undefined ? "" : this.props.optionKey),
                                    }
                                });
                        }}
                        options={safeCodeList}
                        clearOnBlur={this.props.clearOnBlur === undefined ? true : this.props.clearOnBlur}
                        // getOptionSelected={(option, value) => option.name === value.name}
                        getOptionLabel={(option) => option.name || null}
                        data-attr={this.props.attribute}
                        filterOptions={(options, params) => {
                            if (this.props.enableCustomInput) {
                                const filtered = this.filterOptions(options, params);
                                if (params.inputValue !== '') {
                                    filtered.push({
                                        name: `搜尋 “${params.inputValue}”`,
                                        [this.props.optionKey || 'value']: params.inputValue,
                                    });
                                }
                                return filtered;
                            } else {
                                return this.filterOptions(options, params)
                            }
                        }}
                        loading={this.props.loading === undefined ? false : this.props.loading}
                        debug={this.props.debug === undefined ? false : this.props.debug}
                        freeSolo={this.props.freeSolo === undefined ? false : this.props.freeSolo}
                        disabled={this.props.disabled}
                        // 有指定 disableClearable 就以它為準，沒指定時維持原本「必填就不給清除」的行為
                        disableClearable={this.props.disableClearable !== undefined ? !!this.props.disableClearable : !!this.props.required}
                        multiple={isMultiple}
                        limitTags={this.props.limitTags === undefined ? 3 : this.props.limitTags}
                        renderTags={selected => {
                            let renderTagsValue = selected
                                .map(elem => elem?.name || '')
                                .join(", ");
                            return (
                                <Typography
                                    style={{
                                        maxWidth: "64%",
                                        paddingLeft: "12px"
                                    }}
                                    noWrap={true}
                                    color="textPrimary"
                                >
                                    {renderTagsValue}
                                </Typography>
                            );
                        }}
                        getOptionDisabled={this.props.getOptionDisabled ?? (() => false)}
                        renderInput={(params) => {
                            const hasValue = isMultiple ? normalizedValue.length > 0 : !!normalizedValue;
                            const clearButton = (hasValue && !this.props.disabled && !this.props.required
                                && this.props.disableClearable !== true
                                && ((this.props.id ?? "").indexOf("search--") > -1)
                                && this.input?.clientWidth >= 150) ? (
                                <InputAdornment position="end" style={{ marginRight: '24px' }}>
                                    <IconButton
                                        size="small"
                                        style={{ padding: 0 }}
                                        onClick={(e) => {
                                            e.stopPropagation();
                                            if (this.props.changeEvent !== undefined) {
                                                this.props.changeEvent({
                                                    "target": {
                                                        "id": this.props.id,
                                                        "name": this.props.name,
                                                        "value": isMultiple ? [] : "",
                                                        "key": (this.props.optionKey === undefined ? "" : this.props.optionKey),
                                                    }
                                                })
                                            }
                                        }}
                                    >
                                        <Clear fontSize="small" />
                                    </IconButton>
                                </InputAdornment>
                            ) : null;

                            return (
                                <Box display="flex">
                                    <TextField
                                        {...params}
                                        inputRef={input => this.input = input}
                                        required={this.props.required}
                                        onClick={this.props.click}
                                        color={this.props.color === undefined ? "primary" : this.props.color}
                                        error={!!this.props.errorText}
                                        helperText={this.props.errorText || this.props.helperText}
                                        placeholder={this.props.placeholder}
                                        autoComplete={this.props.autoComplete !== undefined ? this.props.autoComplete : "off"}
                                        fullWidth
                                        style={styleObj}
                                        label={this.props.label}
                                        variant={this.props.variant === undefined ? "outlined" : this.props.variant}
                                        InputLabelProps={{
                                            shrink: this.props.shrink !== undefined ? this.props.shrink : true,
                                            ...params.InputLabelProps
                                        }}
                                        InputProps={{
                                            ...params.InputProps,
                                            startAdornment: this.props.startAdornment || params.InputProps.startAdornment ? (
                                                <React.Fragment>
                                                    {this.props.startAdornment}
                                                    {params.InputProps.startAdornment}
                                                </React.Fragment>
                                            ) : null,
                                            endAdornment: this.props.endAdornment || params.InputProps.endAdornment ? (
                                                <React.Fragment>
                                                    {clearButton}
                                                    {this.props.endAdornment}
                                                    {params.InputProps.endAdornment}
                                                </React.Fragment>
                                            ) : null,
                                        }}
                                    />
                                    {this.props.btnGroup !== undefined ?
                                        <ButtonGroup color="primary" style={{ margin: "0.6rem 0.3rem 0.6rem 0" }}>
                                            {this.props.btnGroup}
                                        </ButtonGroup> :
                                        null}
                                </Box>
                            )
                        }} />
                    : this.props.multiple === undefined || this.props.multiple === false ?
                        <FormControl variant={this.props.variant === undefined ? "outlined" : this.props.variant} disabled={this.props.disabled} style={{
                            margin: this.props.margin === undefined ? "0.6rem 0px" : this.props.margin,
                            padding: "0px 4px",
                            maxHeight: '150px', width: "100%"
                        }}>
                            <InputLabel htmlFor="filled-age-native-simple">{this.props.label}</InputLabel>
                            <Select
                                // native
                                disabled={this.props.disabled}
                                MenuProps={{
                                    style: {
                                        maxHeight: 100 * 4.5,
                                    }
                                }}
                                autoWidth={true}
                                open={this.props.open}
                                id={this.props.id}
                                name={this.props.label}
                                label={this.props.label}
                                onClick={this.props.click}
                                onChange={(e) => {
                                    if (this.props.changeEvent !== undefined) {
                                        this.props.changeEvent({
                                            "target": {
                                                "id": this.props.id,
                                                "name": this.props.name,
                                                "value": safeCodeList.length !== 0 ?
                                                    e.target.value === "" ?
                                                        e.target.value :
                                                        safeCodeList.find(item => item[this.props.optionKey].toString() === e.target.value.toString()) :
                                                    null,
                                                "key": (this.props.optionKey === undefined ? "" : this.props.optionKey),
                                            }
                                        })
                                    }
                                }}
                                onOpen={(e) => {
                                    if (this.props.openEvent !== undefined)
                                        this.props.openEvent(e)
                                }}
                                onClose={(e) => {
                                    if (this.props.closeEvent !== undefined)
                                        this.props.closeEvent({
                                            "target": {
                                                "id": this.props.id,
                                                "name": this.props.name,
                                                "key": (this.props.optionKey === undefined ? "" : this.props.optionKey),
                                            }
                                        });
                                }}
                                input={
                                    <OutlinedInput
                                        label={this.props.label}
                                        startAdornment={this.props.startAdornment}
                                        endAdornment={
                                            <React.Fragment>
                                                {(this.props.value && !this.props.disabled && (this.props.id ?? "").indexOf("search--") > -1 && !this.props.required && this.props.disableClearable !== true) ? (
                                                    <InputAdornment position="end" style={{ marginRight: '24px' }}>
                                                        <IconButton
                                                            size="small"
                                                            style={{ padding: 0 }}
                                                            onClick={(e) => {
                                                                e.stopPropagation();
                                                                if (this.props.changeEvent !== undefined) {
                                                                    this.props.changeEvent({
                                                                        "target": {
                                                                            "id": this.props.id,
                                                                            "name": this.props.name,
                                                                            "value": null,
                                                                            "key": (this.props.optionKey === undefined ? "" : this.props.optionKey),
                                                                        }
                                                                    })
                                                                }
                                                            }}
                                                        >
                                                            <Clear fontSize="small" />
                                                        </IconButton>
                                                    </InputAdornment>
                                                ) : null}
                                                {this.props.endAdornment}
                                            </React.Fragment>
                                        }
                                    />
                                }
                                value={this.props.value ? this.props.value[this.props.optionKey] : ""}>
                                {this.props.required === true ? "" : <MenuItem aria-label={this.props.name} value="" role="option" ><em>無選擇</em></MenuItem>}
                                {safeCodeList.length !== 0 ?
                                    safeCodeList.map(item => {
                                        const isDisabled = this.props.getOptionDisabled?.(item) ?? false;
                                        return <MenuItem
                                            key={item[this.props.optionKey]}
                                            value={item[this.props.optionKey]}
                                            disabled={isDisabled}
                                        >
                                            {item.name}
                                        </MenuItem>
                                    }) :
                                    ""}
                            </Select>
                        </FormControl> :
                        <FormControl variant={this.props.variant === undefined ? "outlined" : this.props.variant} disabled={this.props.disabled} style={{
                            margin: this.props.margin === undefined ? "0.6rem 0px" : this.props.margin,
                            padding: "0px 4px",
                            maxHeight: '150px', width: "100%"
                        }}>
                            <InputLabel>{this.props.label}</InputLabel>
                            <Select
                                multiple
                                disabled={this.props.disabled}
                                MenuProps={{
                                    style: {
                                        maxHeight: 100 * 4.5,
                                    }
                                }}
                                autoWidth={true}
                                open={this.props.open}
                                id={this.props.id}
                                name={this.props.label}
                                label={this.props.label}
                                onClick={this.props.click}
                                labelId="demo-mutiple-name-label"
                                onChange={(e, value, reason) => {
                                    if (this.props.changeEvent !== undefined) {
                                        let selectedValues = e.target.value;
                                        this.setState({
                                            selectedValues: value.props.value ? selectedValues : []
                                        });
                                        let mappedValues = [];
                                        if (this.props.codeList !== undefined && this.props.codeList.length !== 0) {
                                            if (value.props.value) {
                                                mappedValues = selectedValues.map(elem =>
                                                    this.props.codeList.find(item => item[this.props.optionKey] === elem)
                                                );
                                            } else {
                                                mappedValues = []
                                            }
                                        }
                                        this.props.changeEvent({
                                            "target": {
                                                "id": this.props.id,
                                                "name": this.props.name,
                                                "value": mappedValues,
                                                "key": (this.props.optionKey === undefined ? "" : this.props.optionKey),
                                            }
                                        });
                                    }
                                }}
                                onOpen={(e) => {
                                    if (this.props.openEvent !== undefined)
                                        this.props.openEvent(e)
                                }}
                                onClose={(e) => {
                                    if (this.props.closeEvent !== undefined)
                                        this.props.closeEvent({
                                            "target": {
                                                "id": this.props.id,
                                                "name": this.props.name,
                                                "key": (this.props.optionKey === undefined ? "" : this.props.optionKey),
                                            }
                                        });
                                }}
                                input={
                                    <OutlinedInput
                                        label={this.props.label}
                                        startAdornment={this.props.startAdornment}
                                        endAdornment={
                                            <React.Fragment>
                                                {(this.state.selectedValues && this.state.selectedValues.length > 0 && !this.props.disabled && (this.props.id ?? "").indexOf("search--") > -1 && !this.props.required && this.props.disableClearable !== true) ? (
                                                    <InputAdornment position="end" style={{ marginRight: '24px' }}>
                                                        <IconButton
                                                            size="small"
                                                            style={{ padding: 0 }}
                                                            onClick={(e) => {
                                                                e.stopPropagation();
                                                                this.setState({ selectedValues: [] });
                                                                if (this.props.changeEvent !== undefined) {
                                                                    this.props.changeEvent({
                                                                        "target": {
                                                                            "id": this.props.id,
                                                                            "name": this.props.name,
                                                                            "value": [],
                                                                            "key": (this.props.optionKey === undefined ? "" : this.props.optionKey),
                                                                        }
                                                                    })
                                                                }
                                                            }}
                                                        >
                                                            <Clear fontSize="small" />
                                                        </IconButton>
                                                    </InputAdornment>
                                                ) : null}
                                                {this.props.endAdornment}
                                            </React.Fragment>
                                        }
                                    />
                                }
                                value={this.state.selectedValues}>
                                {this.props.required === true ? "" : <MenuItem aria-label={this.props.name} value="" role="option" ><em>無選擇</em></MenuItem>}
                                {this.props.codeList !== undefined && this.props.codeList.length !== 0 ?
                                    this.props.codeList.map(item => {
                                        return <MenuItem
                                            key={item[this.props.optionKey]}
                                            value={item[this.props.optionKey]}
                                        >
                                            {item.name}
                                        </MenuItem>
                                    }) :
                                    ""}
                            </Select>
                        </FormControl>
                }
            </React.Fragment>
        );
    }
}

/**
 * ReactOutlineSelect
 * @description 型別判斷
 */
ReactOutlineSelect.propTypes = {
    size: PropTypes.string,
    id: PropTypes.string,
    color: PropTypes.string,
    default: PropTypes.node,
    focused: PropTypes.bool,
    autoFocus: PropTypes.bool,
    change: PropTypes.func,
    clearOnBlur: PropTypes.bool,
    open: PropTypes.func,
    close: PropTypes.func,
    codeList: PropTypes.array,
    loading: PropTypes.bool,
    matchFrom: PropTypes.string,
    debug: PropTypes.bool,
    disabled: PropTypes.bool,
    freeSolo: PropTypes.bool,
    disableClearable: PropTypes.bool,
    clearable: PropTypes.bool,
    required: PropTypes.bool,
    helperText: PropTypes.node,
    placeholder: PropTypes.string,
    label: PropTypes.node,
    shrink: PropTypes.bool,
    attribute: PropTypes.string,
    btnGroup: PropTypes.element
}


/**
 * @description 框線類型選單
 * @param {string} size 選單大小
 * @param {string} id 選單 id
 * @param {string} color 主顏色
 * @param {string} default 預設進畫面顯示的值
 * @param {function} changeEvent 選單 onChange 事件
 * @param {array} codeList 選單選項
 * @param {boolean} disabled 是否禁止改值
 * @param {boolean} required 是否必填
 * @param {node} helperText 輔助文本
 * @param {string} placeholder 提示輸入
 * @param {string} disableClearable true/false 值是否要可以給空值
 * @param {string} clearable true/false 值是否要顯示刪除按鈕
 * @param {node} label input label
 * @param {boolean} shrink label 是否要直接顯示 true/false (如果要focus再出現，此屬性不要給)
 * @param {string} attribute data-attr 要帶系統代碼的spp_id
 * @param {string} closeIcon 清除按鈕
 * @param {string} aria 給 simple 就是不要 padding
 * InputProps 用於Input組件 & inputProps 是為input元素
 * function(event: object, value: T | T[], reason: string) => void ， 例:onChange={(e, value, reason) => this.props.changeEvent(e, value, reason)} 
 */
class ReactOutlineCheckSelect extends Component {
    constructor(props) {
        super(props);
        this.state = {
            optionArr: props.codeList,
        }
    }
    selectType = (value, reason) => {
        if (reason === "select-option") {
            this.setState({
                optionArr: value
            })
        } else if (reason === "remove-option") {
            this.setState({
                optionArr: value
            })
        } else if (reason === "clear") {
            this.setState({
                optionArr: new Array()
            })
        }
    }

    // checkAllChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    //     setCheckAll(event.target.checked);
    //     if (event.target.checked) {
    //       setValue(top100Films);
    //     } else {
    //       setValue([]);
    //     }
    //   };
    render() {
        return (
            <React.Fragment>
                {this.props.tiptitle !== undefined ? // 要不要有 tooltip
                    <Grid item lg={12} md={12} xs={12} style={{ display: "flex", justifyContent: "flex-end", }}>
                        <Tooltip style={{ margin: "0 1rem", padding: "0 !important" }} data-aria={this.props.aria}
                            enterTouchDelay={0}
                            placement={this.props.tipplacement} title={this.props.tiptitle} arrow={this.props.tiparrow}>
                            <IconButton size={this.props.tipsize} color={this.props.tipcolor}>
                                {this.props.tipicon}
                            </IconButton>
                        </Tooltip>
                    </Grid>
                    : ""}
                <Autocomplete
                    style={{ margin: this.props.margin, maxHeight: '150px', width: "100%" }}
                    size="small"
                    id={this.props.id}
                    color={this.props.color === undefined ? "primary" : this.props.color}
                    // value={this.props.value}
                    multiple
                    limitTags={3}
                    disableCloseOnSelect
                    onChange={(e, value, reason) => this.props.changeEvent(
                        {
                            "target": {
                                "id": this.props.id,
                                "name": this.props.name,
                                "value": value,
                                "key": (this.props.optionKey === undefined ? "" : this.props.optionKey),
                            }
                        },
                        // this.state.optionArr = value
                        this.selectType(value, reason)
                    )}
                    options={this.props.codeList}
                    closeIcon=""
                    clearText=""
                    getOptionLabel={(option) => option.name || null}
                    data-attr={this.props.attribute}
                    disabled={this.props.disabled}
                    disableClearable={this.props.required !== undefined ? true : false}
                    // defaultValue={this.state.optionArr.length === this.props.codeList.length ?
                    //      this.state.optionArr.filter(elem => elem.name !== "全部選取") : (option) => option}
                    defaultValue={this.state.optionArr.filter(elem => elem.name !== "全部選取")}
                    renderOption={(option, { selected }) => {
                        const selectFilmIndex = this.state.optionArr.findIndex(film => film.name === "全部選取");
                        if (selectFilmIndex > -1) {
                            selected = true;
                        }
                        return (
                            <React.Fragment>
                                <Checkbox
                                    icon={<CheckBoxOutlineBlank fontSize="small" />}
                                    checkedIcon={<CheckBox fontSize="small" />}
                                    style={{ marginRight: 8 }}
                                    checked={selected}
                                />
                                {option.name}
                            </React.Fragment>
                        )
                    }}
                    renderInput={(params) => (
                        <TextField
                            value={this.props.value}
                            required={this.props.required}
                            // error={this.props.required === true ? (this.props.value === "" ? true : false) : false}
                            // helperText={this.props.required === true ? (this.props.value === "" ? "此為必填欄位" : "") : false}
                            placeholder={this.props.placeholder}
                            autoComplete={this.props.autoComplete !== undefined ? this.props.autoComplete : "off"}
                            color={this.props.color === undefined ? "primary" : this.props.color}
                            fullWidth
                            style={{ margin: this.props.inputStyle === undefined ? "0.6rem 0" : this.props.inputStyle, }}
                            label={this.props.label}
                            variant="outlined"
                            InputLabelProps={{
                                shrink: this.props.shrink !== undefined ? this.props.shrink : true,
                            }}
                            {...params}
                        />
                    )}
                />
            </React.Fragment>
        );
    }
}

// const ReactOutlineCheckSelect = ({
//     props,
//     label,
//     placeholder,
//     selectAllLabel,
//     noOptionsText,
//     limitTags,
//     onChange
// }) => {
//     const [selectedOptions, setSelectedOptions] = useState([]);
//     const allSelected = props.codeList.length === selectedOptions.length;
//     const handleToggleOption = selectedOptions =>
//         setSelectedOptions(selectedOptions);
//     const handleClearOptions = () => setSelectedOptions([]);
//     const getOptionLabel = option => `${option.label}`;
//     const handleSelectAll = isSelected => {
//         if (isSelected) {
//             setSelectedOptions(props.codeList);
//         } else {
//             handleClearOptions();
//         }
//     };

//     const handleToggleSelectAll = () => {
//         handleSelectAll && handleSelectAll(!allSelected);
//     };

//     const handleChange = (event, selectedOptions, reason) => {
//         if (reason === "select-option" || reason === "remove-option") {
//             if (selectedOptions.find(option => option.value === "select-all")) {
//                 handleToggleSelectAll();
//                 let result = [];
//                 result = props.codeList.filter(el => el.value !== "select-all");
//                 return onChange(result);
//             } else {
//                 handleToggleOption && handleToggleOption(selectedOptions);
//                 return onChange(selectedOptions);
//             }
//         } else if (reason === "clear") {
//             handleClearOptions && handleClearOptions();
//         }
//     };
//     const optionRenderer = (option, { selected }) => {
//         const selectAllProps =
//             option.value === "select-all" // To control the state of 'select-all' checkbox
//                 ? { checked: allSelected }
//                 : {};
//         return (
//             <>
//                 <Checkbox
//                     color="primary"
//                     icon={<CheckBoxOutlineBlankIcon fontSize="small" />}
//                     checkedIcon={<CheckBoxIcon fontSize="small" />}
//                     style={{ marginRight: 8 }}
//                     checked={selected}
//                     {...selectAllProps}
//                 />
//                 {getOptionLabel(option)}
//             </>
//         );
//     };
//     const inputRenderer = params => (
//         <TextField {...params} label={label} placeholder={placeholder} />
//     );
//     const getOptionSelected = (option, anotherOption) =>
//         option.value === anotherOption.value;
//     const filter = createFilterOptions();
//     return (
//         <Autocomplete
//             multiple
//             size="small"
//             limitTags={limitTags}
//             options={items}
//             value={selectedOptions}
//             disableCloseOnSelect
//             getOptionLabel={getOptionLabel}
//             getOptionSelected={getOptionSelected}
//             noOptionsText={noOptionsText}
//             filterOptions={(options, params) => {
//                 const filtered = filter(options, params);
//                 return [{ label: selectAllLabel, value: "select-all" }, ...filtered];
//             }}
//             onChange={handleChange}
//             renderOption={optionRenderer}
//             renderInput={inputRenderer}
//         />
//     );
// };

/**
 * @description input 框線類型
 * @param {string} size 大小
 * @param {string} id id
 * @param {string} color 主顏色
 * @param {string} value 指定畫面顯示的值
 * @param {string} defaultValue 預設值
 * @param {boolean} disabled 是否禁止改值
 * @param {boolean} required 是否必填
 * @param {node} helperText 輔助文本
 * @param {string} disableclearable true/false 值是否要可以給空值
 * @param {string} placeholder 提示輸入
 * @param {boolean} shrink label 是否要直接顯示 true/false (如果要focus再出現，此屬性不要給)
 * @param {number} maxLength 字數限制 
 * @param {function} changeEvent input onChange 事件
 * @param {function} onBlur input onBlur 事件
 * @param {string} aria 給 simple 就是不要 padding
 * @param {number} min 最小數字限制
 * @param {number} max 最大數字限制
 * @param {string} variant 樣式 'filled'| 'outlined'| 'standard'
 * @param {string} errorText 錯誤提示
 * ※ InputProps和inputProps是 TextField 的兩個不同屬性，且type="number"，maxLength 將不起作用
 */
class ReactOutlineInput extends Component {
    constructor(props) {
        super(props);
        this.state = {
            innerValue: props.value || props.defaultValue || ""
        }

        this.props.refName === undefined ? this.myRef = React.createRef() : this[this.props.refName] = React.createRef()
    }

    static getDerivedStateFromProps(nextProps, prevState) {
        if (nextProps.value !== undefined && nextProps.value !== prevState.innerValue) {
            return { innerValue: nextProps.value };
        }
        return null;
    }

    /**
     * 檢查類別是否為數字，最大最小值輸入限制
     * @param {*} e 
     */
    checkInputData = (e) => {
        let obj = e;
        const val = obj.target.value;
        this.setState({ innerValue: val });

        if (obj.target.type === "number") {
            let num = "";
            if (this.props.min !== undefined && this.props.max !== undefined) {
                if (Number.parseInt(this.props.min) > Number.parseInt(obj.target.value)) num = this.props.min;
                else if (Number.parseInt(this.props.max) < Number.parseInt(obj.target.value)) num = this.props.max;
                else num = obj.target.value;
            } else if (this.props.min !== undefined) {
                if (Number.parseInt(this.props.min) > Number.parseInt(obj.target.value)) num = this.props.min;
                else num = obj.target.value;
            } else if (this.props.max !== undefined) {
                if (Number.parseInt(this.props.max) < Number.parseInt(obj.target.value)) num = this.props.max;
                else num = obj.target.value;
            } else num = obj.target.value;

            obj.target.value = num;
        }
        this.props.changeEvent(obj);
    }

    getKeyDownEventRef = (e) => {
        let obj = {
            event: e,
            ref: this[this.props.refName],
            refName: this.props.refName
        }
        this.props.KeyDownEvent(obj)
    }

    blurEvent = (e) => {
        if (
            this.props.onBlur
        ) {
            this.props.onBlur(e)
        }

    }

    render() {
        // let telCheck = Regex.IsMatch(tel, @"^09[0-9]{8}$")
        const shouldShowClearIcon = (
            this.state.innerValue &&            // 改用內部 state
            !this.props.disabled &&
            (this.props.id ?? "").indexOf("search--") > -1 &&
            !this.props.required
        );

        return (
            <React.Fragment>
                {this.props.tiptitle !== undefined ? // 要不要有 tooltip
                    <Grid item lg={12} md={12} xs={12} style={{ display: "flex", justifyContent: "flex-end", }}>
                        <Tooltip style={{ margin: "0 1rem", padding: "0 !important" }} data-aria={this.props.aria}
                            enterTouchDelay={0}
                            placement={this.props.tipplacement} title={this.props.tiptitle} arrow={this.props.tiparrow}>
                            <IconButton size={this.props.tipsize} color={this.props.tipcolor}>
                                {this.props.tipicon}
                            </IconButton>
                        </Tooltip>
                    </Grid>
                    : ""}
                <div style={{ margin: this.props.margin, maxHeight: this.props.minRows !== undefined ? 'unset' : '150px', width: "100%" }}>
                    <TextField
                        style={{ margin: this.props.inputStyle === undefined ? "0.6rem 0" : this.props.inputStyle, }}
                        size={this.props.size !== undefined ? this.props.size : "small"}
                        id={this.props.id}
                        type={this.props.type}
                        name={this.props.name}
                        label={this.props.label}
                        defaultValue={this.props.defaultValue}
                        value={this.props.value}
                        placeholder={this.props.placeholder}
                        variant={this.props.variant === undefined ? "outlined" : this.props.variant}
                        color={this.props.color === undefined ? "primary" : this.props.color}
                        error={!!this.props.errorText}
                        helperText={this.props.errorText || this.props.helperText}
                        required={this.props.required}
                        autoComplete={this.props.autoComplete !== undefined ? this.props.autoComplete : "off"}
                        onChange={(e) => this.checkInputData(e)}
                        // onChange={this.props.type !== "date" ? (e) => this.props.changeEvent(e) : null}
                        fullWidth
                        InputLabelProps={{
                            shrink: this.props.shrink !== undefined ? this.props.shrink : true,
                        }}
                        InputProps={{
                            inputProps: {
                                min: this.props.min,
                                max: this.props.max,
                                maxLength: this.props.maxLength,
                                onClick: this.props.click,
                                style: {
                                    textTransform: this.props.uppercase === true ? "uppercase" : "" //大寫轉換
                                }
                            },
                            startAdornment: this.props.startAdornment,
                            endAdornment: (
                                <React.Fragment>
                                    {shouldShowClearIcon ? (
                                        <InputAdornment position="end" style={{ marginRight: '4px' }}>
                                            <IconButton
                                                size="small"
                                                style={{ padding: 0 }}
                                                onClick={(e) => {
                                                    this.setState({ innerValue: "" });
                                                    // 強制清空 DOM 的值 (解決畫面字沒消失的問題)
                                                    const currentRef = this.props.refName === undefined ? this.myRef : this[this.props.refName];
                                                    //console.log("currentRef", currentRef);
                                                    if (currentRef && currentRef.current) {
                                                        const inputEl = currentRef.current.querySelector ? currentRef.current.querySelector('input') : currentRef.current;
                                                        if (inputEl) inputEl.value = "";
                                                    }

                                                    if (this.props.changeEvent !== undefined) {
                                                        this.props.changeEvent({
                                                            "target": {
                                                                "id": this.props.id,
                                                                "name": this.props.name,
                                                                "value": "",
                                                                "type": this.props.type,
                                                            }
                                                        })
                                                    }
                                                }}
                                            >
                                                <Clear fontSize="small" />
                                            </IconButton>
                                        </InputAdornment>
                                    ) : null}
                                    {this.props.endAdornment}
                                </React.Fragment>
                            )
                        }}
                        onBlur={(e) => this.blurEvent(e)}

                        // InputProps={{
                        //     endAdornment: (
                        //         <IconButton size="small">
                        //             <Clear />
                        //         </IconButton>
                        //     )
                        // }}
                        maxRows={this.props.maxRows === undefined ? "" : this.props.maxRows}
                        rows={this.props.rows}
                        minRows={this.props.minRows}
                        multiline={!!this.props.rows || !!this.props.maxRows || !!this.props.minRows}
                        disabled={this.props.disabled}
                        onKeyDown={this.props.keyEvent === undefined ? (e) => "" : (e) => this.getKeyDownEventRef(e)}
                        ref={this.props.refName === undefined ? this.myRef : this[this.props.refName]}
                    />
                </div>
            </React.Fragment>
        );
    }
}
/**
 * ReactOutlineInput
 * @description 型別判斷
 */
ReactOutlineInput.propTypes = {
    size: PropTypes.string,
    id: PropTypes.string,
    color: PropTypes.string,
    defaultValue: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.number,
        PropTypes.oneOf([null])  // 額外加上 null 支援
    ]),
    disabled: PropTypes.bool,
    required: PropTypes.bool,
    helperText: PropTypes.node,
    placeholder: PropTypes.string,
    label: PropTypes.node,
    shrink: PropTypes.bool,
    maxLength: PropTypes.number,
    change: PropTypes.func,
}

/**
 * @description input 底線類型
 * @param {string} size 選單大小
 * @param {string} id 選單 id
 * @param {string} color 主顏色
 * @param {string} default 預設進畫面顯示的值
 * @param {boolean} disabled 是否禁止改值
 * @param {boolean} required 是否必填
 * @param {node} helperText 輔助文本
 * @param {string} disableclearable true/false 值是否要可以給空值
 * @param {string} placeholder 提示輸入
 * @param {boolean} shrink label 是否要直接顯示 true/false (如果要focus再出現，此屬性不要給)
 * @param {number} maxLength 字數限制 
 * @param {string} aria 給 simple 就是不要 padding
 * ※ InputProps和inputProps是 TextField 的兩個不同屬性，且type="number"，maxLength 將不起作用
 */
class ReactUnderLineInput extends Component {
    constructor(props) {
        super(props);
        this.state = {}
    }
    /**
     * 檢查類別是否為數字，最大最小值輸入限制
     * @param {*} e 
     */
    checkInputData = (e) => {
        let obj = e;
        const regex = /^[0-9\b]+$/;
        if (obj.target.type === "number") {
            let num = ''
            // e.target.value.replace(regex, '');
            // if (num !== '') {
            if (this.props.min !== undefined && this.props.max !== undefined) {
                if (Number.parseInt(this.props.min) > Number.parseInt(obj.target.value)) num = this.props.min;
                else if (Number.parseInt(this.props.max) < Number.parseInt(obj.target.value)) num = this.props.max;
                else num = obj.target.value;
            } else if (this.props.min !== undefined) {
                if (Number.parseInt(this.props.min) > Number.parseInt(obj.target.value)) num = this.props.min;
                else num = obj.target.value;
            } else if (this.props.max !== undefined) {
                if (Number.parseInt(this.props.max) < Number.parseInt(obj.target.value)) num = this.props.max;
                else num = obj.target.value;
            } else num = obj.target.value;
            obj.target.value = num;
            // }
        }
        this.props.changeEvent(obj);
    }

    render() {
        return (
            <React.Fragment>
                {this.props.tiptitle !== undefined ? // 要不要有 tooltip
                    <Grid item lg={12} md={12} xs={12} style={{ display: "flex", justifyContent: "flex-end", }}>
                        <Tooltip style={{ margin: "0 1rem", padding: "0 !important" }} data-aria={this.props.aria}
                            enterTouchDelay={0}
                            placement={this.props.tipplacement} title={this.props.tiptitle} arrow={this.props.tiparrow}>
                            <IconButton size={this.props.tipsize} color={this.props.tipcolor}>
                                {this.props.tipicon}
                            </IconButton>
                        </Tooltip>
                    </Grid>
                    : ""}
                <div style={{ margin: this.props.margin, maxHeight: '150px', width: "100%" }}>
                    <TextField
                        id={this.props.id}
                        name={this.props.name}
                        size={this.props.size}
                        label={this.props.label}
                        type={this.props.type}
                        autoComplete={this.props.autoComplete !== undefined ? this.props.autoComplete : "off"}
                        placeholder={this.props.placeholder}
                        required={this.props.required}
                        // error={this.props.required === true ? (this.props.value === "" ? true : false) : false}
                        // helperText={this.props.required === true ? (this.props.value === "" ? "此為必填欄位" : "") : false}
                        // defaultValue={this.state.default}
                        value={this.props.value}
                        color={this.props.color === undefined ? "primary" : this.props.color}
                        onChange={(e) => this.checkInputData(e)}
                        fullWidth
                        InputProps={{
                            inputProps: {
                                min: this.props.min,
                                max: this.props.max,
                                maxLength: this.props.maxLength,
                                // inputMode: this.props.type === 'number' ? 'numeric' : '',
                                // pattern: this.props.type === 'number' ? '[0-9]*' : '',
                                style: {
                                    textTransform: this.props.uppercase === true ? 'uppercase' : '' //大寫轉換
                                }
                            },
                            startAdornment: this.props.startAdornment,
                            endAdornment: this.props.endAdornment
                        }}
                        InputLabelProps={{
                            style: { margin: "-7px 0" },
                            shrink: this.props.shrink !== undefined ? this.props.shrink : true,
                        }}
                        style={{ margin: "0.5rem 0" }}
                        disabled={this.props.disabled}
                    />
                </div>
            </React.Fragment>
        )
    }
}
/**
 * ReactUnderLineInput
 * @description 型別判斷
 */
ReactUnderLineInput.propTypes = {
    size: PropTypes.string,
    id: PropTypes.string,
    name: PropTypes.string,
    color: PropTypes.string,
    // default: PropTypes.node,
    disabled: PropTypes.bool,
    required: PropTypes.bool,
    helperText: PropTypes.node,
    placeholder: PropTypes.string,
    shrink: PropTypes.bool,
    maxLength: PropTypes.number,
}


/**
 * @description 框線類型日期選擇器
 * @param {string} locale 顯示語言 date-fns/locale 資料夾裡的資料夾 依據index.d.ts檔案內容給參數
 * @param {string} id id
 * @param {string} label 標籤
 * @param {string} variant 跳出形式 "dialog" | "inline" | "static"
 * @param {string} size 大小
 * @param {string} value 值  給空值會被判斷成格式錯誤
 * @param {function} changeEvent onChange 事件
 * @param {string} invalidDateMessage 無效日期 提示文字
 * @param {boolean} showTodayButton 選擇今日按鈕
 * @param {boolean} autoOk 選擇日期就關閉選擇器
 * @param {boolean} disabled 是否可填
 * @param {boolean} required 是否必填
 * @param {Array} views ["date"] ["year"] ["month"] 
 */
class ReactUnderLineDatePicker extends Component {
    constructor(props) {
        super(props);
        this.state = {}
    }
    render() {
        return (
            <MuiPickersUtilsProvider utils={DateFnsUtils} locale={zhTW}>
                <div style={{ margin: this.props.margin, maxHeight: '150px', width: "100%" }}>
                    <KeyboardDatePicker
                        style={{ margin: "0.5rem 0" }}
                        id={this.props.id}
                        label={this.props.label}
                        readOnly={this.props.readOnly === undefined ? false : this.props.readOnly}
                        color={this.props.color === undefined ? "primary" : this.props.color}
                        variant={this.props.variant === undefined ? "dialog" : this.props.variant}
                        inputVariant="standard" // 框線樣式
                        format={this.props.format === undefined ? "yyyy/MM/dd" : this.props.format} //顯示型態
                        views={this.props.views === undefined ? ["date"] : this.props.views}
                        size={this.props.size !== undefined ? this.props.size : "small"}
                        value={this.props.value ? DateTimeFormate.dateFormate({ dateStr: this.props.value }) : null}
                        autoComplete={this.props.autoComplete !== undefined ? this.props.autoComplete : "off"}
                        InputAdornmentProps={{ position: "end", }}
                        onChange={(e) => this.props.changeEvent({ "target": { "name": this.props.name, "value": e, "type": "date", } })}
                        KeyboardButtonProps={{
                            size: "small",
                            "aria-label": "change date"
                        }}
                        invalidDateMessage={this.props.required ? (this.props.invalidDateMessage === undefined ?
                            "請選擇有效日期格式" : this.props.invalidDateMessage) : ""}
                        minDate={this.props.minDate}
                        maxDate={this.props.maxDate}
                        maxDateMessage={"請注意 ! 最大可選日期為 " + (this.props.maxDate ? DateTimeFormate.dateToString({ date: this.props.maxDate, Mode: "yyyyMMdd", joinDate: "-" }) : "(2100-01-01)")}
                        minDateMessage={"請注意 ! 最小可選日期為 " + (this.props.minDate ? DateTimeFormate.dateToString({ date: this.props.minDate, Mode: "yyyyMMdd", joinDate: "-" }) : "(1900-01-01)")}
                        showTodayButton={this.props.showTodayButton !== undefined ? this.props.showTodayButton : true}
                        autoOk={this.props.autoOk}
                        okLabel="確認"
                        cancelLabel="取消"
                        todayLabel="今日"
                        disabled={this.props.disabled}
                        // error={this.props.required === true ? (this.props.value === "" ? true : false) : false}
                        // helperText={this.props.required === true ? (this.props.value === "" ? "此為必填欄位" : "") : false}
                        required={this.props.required}
                        InputProps={{
                            startAdornment: this.props.startAdornment,
                            endAdornment: this.props.endAdornment,
                        }}
                        InputLabelProps={{
                            style: { margin: "-7px 0" },
                            shrink: this.props.shrink !== undefined ? this.props.shrink : true,
                        }}
                        keyboardIcon={<EventRounded size="small" fontSize="inherit" />}
                        fullWidth
                    />
                </div>
            </MuiPickersUtilsProvider>
        );
    }
}

/**
 * @description 型別判斷
 */
ReactUnderLineDatePicker.propTypes = {
    id: PropTypes.string,
    label: PropTypes.string,
    variant: PropTypes.string,
    size: PropTypes.string,
    value: PropTypes.string,
    invalidDateMessage: PropTypes.string,
    showTodayButton: PropTypes.bool,
    autoOk: PropTypes.bool,
    disabled: PropTypes.bool,
    required: PropTypes.bool,
}


/**
 * @description radio 有label類型 (使用 json 產生選項的類型) row 要横向佈置，請將 row 屬性設置為：<RadioGroup row />
 * @param {string} value 預設進畫面顯示的值
 * @param {boolean} disabled 是否禁止改值
 * @param {string} color 主顏色
 * @param {string} style 關閉 margin && maxHeight style
 */
class ReactRadio extends Component {
    constructor(props) {
        super(props);
        this.state = {
            value: props.radioVal
        }
        this.handleChange.bind(this);
    }
    handleChange = (event) => {
        this.setState({
            value: event.target.value,
        })
    };
    render() {
        return (
            <RadioGroup value={this.state.value}
                onChange={(e) => this.props.changeEvent(e)} style={this.props.style === undefined ?
                    { margin: "1rem", maxHeight: '150px' } : this.props.style} row>
                {this.props.jsonD.map((item, index) => {
                    let resObj = { key: item.key, type: item.type, value: item.value }
                    return (
                        <FormControlLabel key={item.type + "_" + index} disabled={this.props.disabled} value={resObj.key}
                            control={<Radio name={this.props.name} color={this.props.color === undefined ? "primary" : this.props.color}
                                checked={this.props.radioVal === resObj.key ? true : false} />} label={resObj.key} style={{ color: "#0000008a" }} />
                    )
                })}
            </RadioGroup>
        );
    }
}
/**
 * ReactRadio
 * @description 型別判斷
 */
ReactRadio.propTypes = {
    value: PropTypes.bool,
    disabled: PropTypes.bool,
    color: PropTypes.string,
}
/**
 * @description 上傳檔案用
 * 
 */
class ReactUploadFile extends Component {
    render() {
        return (
            <label className={"file-input ellipsis-normal"}
                htmlFor={this.props.id}
                data-id={this.props.id}
                style={{
                    width: "100%",
                    margin: "0.6rem 0px",
                    padding: "0",
                    border: "1px solid #0000003b"
                }}>
                <input type="file"
                    id={this.props.id}
                    onChange={e => {
                        let inputs = document.querySelector(`.file-input[data-id="${this.props.id}"]`);
                        let span = document.querySelector(`[data-js-label][data-id="${this.props.id}"]`);

                        if (!e.target.value) return;
                        let value = e.target.value.replace(/^.*[\\\/]/, "");
                        inputs.className += " -chosen";
                        span.innerText = value;
                    }}
                />
                <button type="button">{this.props.label === undefined ? "選擇" : "選擇" + this.props.label}</button>
                <span className="label" data-id={this.props.id} data-js-label>尚未選擇檔案</span>
            </label>
        );
    }
}
/**
 * ReactUploadFile
 * @description 型別判斷
 */
ReactUploadFile.propTypes = {
    id: PropTypes.string,
}

/**
 * @description 上傳檔案用
 * 
 */
class ReactUploadReFile extends Component {
    constructor(props) {
        super(props);
        this.state = {
            files: !!props.files ? props.files : null,
        }
        this.fileInput = React.createRef();

        this.fileHandler = this.fileHandler.bind(this);
        this.clearHandler = this.clearHandler.bind(this);
    }

    getState = (stateName) => this.state[stateName];

    async componentDidMount() {
        if (!!this.state.files && typeof this.state.files === 'string') {
            pathToFile(this.state.files, this.props.url).then(file => {
                this.setState({
                    files: file,
                });
            }).catch(error => {
                console.error(error);
            });
        }
    }

    componentDidUpdate(prevProps) {
        if (this.props.files !== prevProps.files) {
            if (!this.props.files) {
                this.fileInput.current.value = '';
                this.setState({
                    files: null,
                });
            }
        }
    }

    fileHandler = (e) => {
        console.log(e.target.files)

        if (e.target.files && e.target.files.length > 0) {
            let file = e.target.files[0];
            console.log(file)

            this.setState({
                files: file,
            });
            if (!!this.props.changeEvent) {
                this.props.changeEvent(e);
            }
        }
    }

    clearHandler = (e) => {
        e.stopPropagation();
        this.setState({
            files: null,
        });
        this.fileInput.current.value = '';
        if (!!this.props.clearEvent) {
            this.props.clearEvent(e)
        }
    }

    render() {
        return (
            <div style={{ width: "100%" }} className="middle">
                <label className={"file-input ellipsis-normal"}
                    htmlFor={this.props.id}
                    data-id={this.props.id}
                    style={{
                        width: "100%",
                        margin: "0.6rem 0px",
                        padding: "0",
                        border: "1px solid #0000003b"
                    }}>
                    <input type="file"
                        id={this.props.id}
                        file={this.state.files}
                        ref={this.fileInput}
                        onChange={e => {
                            if (!e.target.value) return;
                            this.fileHandler(e);
                        }}
                        disabled={this.props.disabled === undefined || this.props.disabled === false ? false : this.props.disabled} />
                    {this.props.disabled === undefined || this.props.disabled === false ? <button type="button">選擇</button> : null}
                    <span className={this.state.files !== null ? "label-chosen" : "label"}
                        style={{ padding: "0 5px" }} data-id={this.props.id} data-js-label>
                        {!!this.state.files ? this.state.files.name : "尚未選擇檔案"}
                    </span>
                </label>
                {this.state.files !== null ? <button type='button' className='clear-input'
                    onClick={(e) => this.clearHandler(e)}>清除</button> : ''}
            </div>
        );
    }
}

function pathToFile(filePath, fileName) {
    return new Promise((resolve, reject) => {
        fetch(filePath)
            .then(response => response.blob())
            .then(blob => {
                const file = new File([blob], fileName, {
                    lastModified: new Date(),
                    type: blob.type,
                });
                resolve(file);
            })
            .catch(error => reject(error));
    });
}

/**
 * ReactUploadReFile
 * @description 型別判斷
 */
ReactUploadReFile.propTypes = {
    id: PropTypes.string,
    changeEvent: PropTypes.func,
    clearEvent: PropTypes.func,
    required: PropTypes.bool,
}

/**
 * @description 上傳檔案用，而且帶有預覽
 */
class ReactUploadFilePreview extends Component {
    render() {
        let { disabled } = { ...this.props };
        return (
            <>
                <div className={"file-input ellipsis-normal" + (this.props.fileName ? " -chosen" : "")}
                    data-id={this.props.id}
                    style={{
                        lineHeight: "1.1876em",
                        margin: "0.6rem 0.3rem",
                        padding: "0px",
                        border: `1px solid ${!!this.props.errorText ? "#f44336" : "#0000003b"}`,
                        borderRadius: "4px",
                        width: "100%",
                    }}>
                    <input disabled={disabled} type="file" id={this.props.id} style={{ display: "none" }}
                        onChange={(e) => {
                            let inputs = document.querySelector(`.file-input[data-id="${this.props.id}"]`);
                            let fileInput = document.querySelector(`input[type='file'][id="${this.props.id}"]`);
                            let label = document.querySelector(`[data-js-label][data-id="${this.props.id}"]`);
                            if (!fileInput.value) return;
                            let value = fileInput.value.replace(/^.*[\\\/]/, "");
                            inputs.className += " -chosen";
                            label.innerText = value;

                            if (this.props.changeEvent !== undefined && this.props.changeEvent !== null)
                                this.props.changeEvent({
                                    "target": {
                                        "id": this.props.id,
                                        "name": this.props.name,
                                        "value": fileInput.value,
                                        "files": fileInput.files,
                                        "key": (this.props.optionKey === undefined ? "" : this.props.optionKey),
                                    }
                                });
                        }} />
                    <button type="button"
                        disabled={disabled}
                        id={this.props.id}
                        onClick={(e) => {
                            if (disabled) return;
                            let fileInput = document.querySelector(`input[type='file'][id="${this.props.id}"]`);
                            fileInput.click();
                        }}>
                        <span>{this.props.label === undefined ? "選擇" : "選擇" + this.props.label}</span>
                        {
                            this.props.required && <span style={{ color: "red" }}> *</span>
                        }
                    </button>
                    <div className="label" data-id={this.props.id} data-js-label>
                        <a href={this.props.filePath} target="_blank"
                            style={{
                                borderBottom: "1px solid #5b6fac",
                            }}>
                            {this.props.fileName === undefined ? "尚未選擇檔案" : this.props.fileName}
                        </a>
                    </div>
                    {/* 
                <div className="label" data-id={this.props.id} data-js-label>
                    <a href={this.props.filePath} target="_blank"
                        style={{
                            borderBottom: "1px solid #5b6fac",
                            color: !!this.props.errorText ? "#f44336" : "#0000003b",
                        }}>
                        {this.props.errorText || this.props.fileName === undefined ? "尚未選擇檔案" : this.props.fileName}
                    </a>
                </div>
                */}
                </div >
                {
                    (this.props.errorText || this.props.helperText) &&
                    <p
                        style={{
                            color: !!this.props.errorText ? "#f44336" : "#0000008a",
                            fontSize: "0.75rem",
                            margin: "4px 14px 0px",
                            padding: '0px 0.3rem',
                            lineHeight: "1.66",
                            letterSpacing: "0.03333em",
                            fontFamily: ["Roboto", "Helvetica", "Arial", "sans-serif"]
                        }}
                    >{this.props.errorText || this.props.helperText}</p>
                }
            </>
        );
    }
}
/**
 * ReactUploadFilePreview
 * @description 型別判斷
 */
ReactUploadFilePreview.propTypes = {
    id: PropTypes.string,
    errorText: PropTypes.string,
}

/**
 * @description 上傳圖片用
 * 
 */
class ReactUploadImgFile extends Component {
    constructor(props) {
        super(props);
        this.state = {
            files: props.files === "" ? null : props.files,
            previewUrl: null,
        }
        this.fileInput = React.createRef();

        this.fileHandler = this.fileHandler.bind(this);
        this.clearHandler = this.clearHandler.bind(this);
    }
    async componentDidMount() {
        let fileName = this.props.imagePreviewUrl.replace(/^.*[\\\/]/, "");
        pathToFile(this.state.files, fileName).then(file => {
            // let base64 = await base64FromFile(file);
            this.setState({
                files: file,
                // previewUrl: base64
            });
        }).catch(error => {
            console.error(error);
        });
    }

    fileHandler = (e) => {
        if (e.target.files && e.target.files.length > 0) {
            let file = e.target.files[0];
            // let base64 = await base64FromFile(file);
            this.setState({
                files: file,
                // previewUrl: base64
            });
            this.props.changeEvent(e);
        }
    }

    clearHandler = (e) => {
        e.stopPropagation();
        this.setState({
            files: null,
            previewUrl: null,
        });
        this.fileInput.current.value = '';
        if (!!this.props.clearEvent) {
            this.props.clearEvent(e)
        }
    }

    render() {
        return (
            <div style={{ display: "grid", justifyContent: "center", justifyItems: "center" }}>
                <div className='file-img-preview hasBorder'>
                    <img style={{ height: "100%" }}
                        src={this.state.previewUrl === null ? this.props.imagePreviewUrl : this.state.previewUrl}
                        onError={(e) => {
                            let elem = e.target;
                            // 將圖片的src屬性更改為預設圖片的路徑
                            elem.src = 'https://fakeimg.pl/300x300?text=miss%20src';
                            // 也可以執行其他操作，例如記錄錯誤、顯示提示訊息等
                        }}
                    />
                </div>
                <Grid item lg={12} md={12} xs={12} style={{ margin: "1rem 0" }}>{this.props.description}</Grid>
                <div style={{ width: "100%" }} className="middle">
                    <label className="file-img-input ellipsis-normal"
                        htmlFor={this.props.id}
                        data-id={this.props.id}
                        style={{
                            width: "100%",
                            margin: "0.6rem 0px",
                            padding: "0",
                            border: "1px solid #0000003b"
                        }}>
                        <input type="file"
                            id={this.props.id}
                            file={this.state.files}
                            ref={this.fileInput}
                            onChange={e => {
                                if (!e.target.value) return;
                                this.fileHandler(e);
                            }}
                            disabled={this.props.disabled === undefined || this.props.disabled === false ? false : this.props.disabled}
                        />
                        {this.props.disabled === undefined || this.props.disabled === false ? <button type="button">選擇</button> : null}
                        <span className={this.state.files !== null ? "label-chosen" : "label"}
                            style={{ padding: "0 5px" }} data-id={this.props.id} data-js-label>
                            {this.state.files !== null ? this.state.files.name : "尚未選擇檔案"}
                        </span>
                    </label>
                    {this.state.files !== null && this.props.disabled === false ? <button type='button' className='clear-input'
                        onClick={(e) => this.clearHandler(e)}>清除</button> : ''}
                </div>
            </div>
        );
    }
}

/**
 * @description input 框線類型 有 mask 限制輸入內容
 */
class ReactMaskedInput extends Component {
    constructor(props) {
        super(props);
        this.state = {
            mask: ""
        }
    }

    componentDidMount() {
        let mask = "";
        if (this.props.masktype === "credit") {
            mask = "9999 - 9999 - 9999 - 9999";
        } else if (this.props.masktype === "phone") {
            mask = "";
        }

        this.setState({
            mask: mask
        })
    }

    render() {
        return (
            <React.Fragment>
                {this.props.tiptitle !== undefined ? // 要不要有 tooltip
                    <Grid item lg={12} md={12} xs={12} style={{ display: "flex", justifyContent: "flex-end", }}>
                        <Tooltip style={{ margin: "0 1rem", padding: "0 !important" }} data-aria={this.props.aria}
                            enterTouchDelay={0}
                            placement={this.props.tipplacement} title={this.props.tiptitle} arrow={this.props.tiparrow}>
                            <IconButton size={this.props.tipsize} color={this.props.tipcolor}>
                                {this.props.tipicon}
                            </IconButton>
                        </Tooltip>
                    </Grid>
                    : ""}
                <div style={{ margin: this.props.margin, maxHeight: '150px', width: "100%" }}>
                    <InputMask
                        mask={this.state.mask}
                        value={this.props.value}
                        maskPlaceholder="_"
                        alwaysShowMask={true}
                        disabled={this.props.disabled}
                        onChange={(e) => this.props.changeEvent(e)}>
                        <TextField
                            style={{ margin: "0.5rem 0" }}
                            size={this.props.size !== undefined ? this.props.size : "small"}
                            id={this.props.id}
                            type={this.props.type}
                            name={this.props.name}
                            label={this.props.label}
                            // defaultValue={this.state.default}
                            value={this.props.value}
                            placeholder={this.props.placeholder}
                            variant="outlined"
                            fullWidth
                            InputLabelProps={{
                                shrink: this.props.shrink !== undefined ? this.props.shrink : true,
                            }}
                            color={this.props.color === undefined ? "primary" : this.props.color}
                            // error={this.props.required === true ? (this.props.value === "" ? true : false) : false}
                            // helperText={this.props.required === true ? (this.props.value === "" ? "此為必填欄位" : "") : false}
                            required={this.props.required}
                            autoComplete={this.props.autoComplete !== undefined ? this.props.autoComplete : "off"}
                        />
                    </InputMask>
                </div>
            </React.Fragment>
        );
    }
}

/**
 * @description textarea 框線類型
 * @param {string} placeholder 提示輸入
 * @param {number} maxRows 顯示的最大行數
 * @param {number} minRows 顯示的最小行數
 */
class ReactTextarea extends Component {
    constructor(props) {
        super(props);
        this.state = {}
    }

    render() {
        return (
            <TextareaAutosize
                id={this.props.id}
                type={this.props.type}
                name={this.props.name}
                value={this.props.value}
                disabled={this.props.disabled}
                onChange={(e) => this.props.changeEvent(e)}
                className='MuiTextArea'
                placeholder={this.props.placeholder === undefined ? "尚未輸入" : this.props.placeholder}
                maxRows={this.props.maxRows}
                minRows={this.props.minRows === undefined ? 1 : this.props.minRows}
                {...this.props}
            />
        );
    }
}
/**
 * ReactTextarea
 * @description 型別判斷
 */
ReactTextarea.propTypes = {
    placeholder: PropTypes.string,
    maxRows: PropTypes.number,
    minRows: PropTypes.number,
}

/**
 * @description input group 框線類型
 * @param {string} variant 樣式 'filled'| 'outlined'| 'standard'
 */
// class ReactOutlineGroupInput extends Component {
//     constructor(props) {
//         super(props);
//         this.state = {}
//     }
//     render() {
//         console.log(this.props.group)
//         let str = '';
//         return (
//             <Box display="flex" flexWrap="wrap" alignContent="flex-start">
//                 {this.props.group.map((item, index) => {
//                     switch (item.type) {
//                         case 'select':
//                             str = <Grid item lg={3} md={3} xs={12}>
//                                 <FormControl variant="outlined" style={{
//                                     margin: this.props.margin === undefined ? "0.6rem 0px" : this.props.margin,
//                                     padding: "0px 4px",
//                                     maxHeight: '150px', width: "100%"
//                                 }}>
//                                     <InputLabel htmlFor="filled-age-native-simple">{item.label}</InputLabel>
//                                     <Select
//                                         // native
//                                         MenuProps={{
//                                             style: {
//                                                 maxHeight: 100 * 4.5,
//                                             }
//                                         }}
//                                         autoWidth={true}
//                                         id={item.id}
//                                         name={item.label}
//                                         label={item.label}
//                                         onChange={(e) => {
//                                             console.log(e.target.value)
//                                             if (this.props.changeEvent !== undefined) {
//                                                 this.props.changeEvent({
//                                                     "target": {
//                                                         "id": this.props.id,
//                                                         "name": this.props.name,
//                                                         "value": this.props.codeList !== undefined || this.props.codeList.lenght !== 0 ?
//                                                             e.target.value === "" ?
//                                                                 e.target.value :
//                                                                 this.props.codeList.find(item => item[this.props.optionKey].toString() === e.target.value.toString()) :
//                                                             null,
//                                                         "key": (this.props.optionKey === undefined ? "" : this.props.optionKey),
//                                                     }
//                                                 })
//                                             }
//                                         }}
//                                         onOpen={(e) => {
//                                             if (this.props.openEvent !== undefined)
//                                                 this.props.openEvent(e)
//                                         }}
//                                         onClose={(e) => {
//                                             if (this.props.closeEvent !== undefined)
//                                                 this.props.closeEvent({
//                                                     "target": {
//                                                         "id": this.props.id,
//                                                         "name": this.props.name,
//                                                         "key": (this.props.optionKey === undefined ? "" : this.props.optionKey),
//                                                     }
//                                                 });
//                                         }}
//                                         inputProps={{
//                                             name: item.label,
//                                             id: item.id,
//                                         }}
//                                         disabled={item.disabled}
//                                         required={item.required}
//                                         style={{ padding: "0" }}
//                                         value={item.value ? item.value[item.optionKey] : ""}>
//                                         {item.required === true ? "" : <MenuItem aria-label={item.name} value="" role="option" ><em>無選擇</em></MenuItem>}
//                                         {item.codeList !== undefined && item.codeList.length !== 0 ?
//                                             item.codeList.map((item) => {
//                                                 // return <MenuItem key={item[this.props.optionKey]} value={item[this.props.optionKey]}>{item.name}</MenuItem>
//                                                 return <MenuItem key={item[this.props.optionKey]} value={item[this.props.optionKey]}>{item.name}</MenuItem>
//                                             }) : ""}
//                                     </Select>
//                                 </FormControl>
//                             </Grid>
//                             break;
//                         case 'input':
//                             str = <Grid item lg={4} md={4} xs={12}>
//                                 <TextField
//                                     style={{ margin: this.props.inputStyle === undefined ? "0.6rem 0" : this.props.inputStyle, }}
//                                     size={this.props.size !== undefined ? this.props.size : "small"}
//                                     id={item.id}
//                                     type={item.type}
//                                     name={item.name}
//                                     label={item.label}
//                                     value={item.value}
//                                     placeholder={item.placeholder}
//                                     variant={item.variant === undefined ? "outlined" : item.variant}
//                                     color={this.props.color === undefined ? "primary" : this.props.color}
//                                     required={item.required}
//                                     autoComplete={this.props.autoComplete !== undefined ? this.props.autoComplete : "off"}
//                                     onChange={(e) => this.checkInputData(e)}
//                                     fullWidth
//                                     InputLabelProps={{
//                                         shrink: this.props.shrink !== undefined ? this.props.shrink : true,
//                                     }}
//                                     InputProps={{
//                                         inputProps: {
//                                             min: this.props.min,
//                                             max: this.props.max,
//                                             maxLength: this.props.maxLength,
//                                             style: {
//                                                 textTransform: this.props.uppercase === true ? "uppercase" : "" //大寫轉換
//                                             }
//                                         },
//                                         startAdornment: this.props.startAdornment,
//                                         endAdornment: this.props.endAdornment
//                                     }}
//                                     onBlur={(e) => this.blurEvent(e)}
//                                     maxRows={this.props.maxRows === undefined ? "" : this.props.maxRows}
//                                     multiline={this.props.rows === undefined ? this.props.maxRows === undefined ? false : true : true}
//                                     disabled={this.props.disabled}
//                                     onKeyDown={this.props.keyEvent === undefined ? (e) => "" : (e) => this.getKeyDownEventRef(e)}
//                                     ref={this.props.refName === undefined ? this.myRef : this[this.props.refName]}
//                                 />
//                             </Grid>
//                             break;
//                         default:
//                             console.log(``);
//                     }
//                     return str;
//                 })}
//             </Box>
//         )
//     }
// }

export {
    ReactMultDatePicker,
    ReactMultTimePicker2,
    ReactOutlineDatePicker,
    ReactOutlineTimePicker,
    ReactOutlineTimePicker2,
    ReactOutlineDateTimePicker,
    ReactOutlineCheckSelect,
    ReactOutlineSelect,
    ReactOutlineInput,
    ReactUnderLineInput,
    ReactUnderLineDatePicker,
    ReactRadio,
    ReactUploadFile,
    ReactUploadReFile,
    ReactUploadFilePreview,
    ReactUploadImgFile,
    ReactMaskedInput,
    ReactTextarea,
    // ReactOutlineGroupInput
};

// React.forwardRef((props, ref) => { <ReactOutlineSelect {...props} forwardRef={ref} /> })